const iconNames = {
	Основной: "ticket-category",
	Детский: "user-child",
};

class OrderHelper {
	constructor() {}

	/**
	 * Заполняет шаблон билета данными
	 * @param $ticket
	 * @param data {Object} - {
	 *   sector or view_id,
	 *   sid or id,
	 *   event_id,
	 *   row,
	 *   col,
	 *   price
	 * }

	 */
	insertDataToTicket($ticket, data) {
		let sector = data.sector || data.view_id;
		const sid = data.sid || data.id;
		const currentEventId = data.event_id;
		const priceId = data.price_view_id || data.price_id;
		const name = data.name || `Ряд ${data.row} место ${data.col}`;
		let ticketClassName = null;
		$ticket.find(".price-category-select-price").hide();
		$ticket.find(".js-ticket-price").text(data.price ? data.price : "");
		if (data.allowedLoyaltyCategories.length) {
			$ticket.find(".ticket-item__place-price").hide();
			$ticket.find(".price-category-select-price").show();
		}
		if ($('.places__content').hasClass('places_service') && ((data.sector != "Заточка") && (data.sector != "Помощник для катания детский") && (data.sector != 'Входной билет'))) {
			$ticket.find(".js-ticket-sector").text(`${sector} размер ${data.col}`);
		} else {
			$ticket.find(".js-ticket-sector").text(sector);
		}
		!data.is_pack && !data.hide ? $ticket.find(".js-ticket-place").text(name) : "";
		if (data.allowedLoyaltyCategories?.length && $(".price-category-select")) {
			$ticket.find(".ticket-item__bottom").append(this.insertLoyaltyCategories(data));
			ticketClassName = "ticket-item_large";
		}

		$ticket
			.find(".ticket-item")
			.attr("data-place", sid)
			.attr("data-uid", data.uid)
			.attr("data-id", data.id)
			.attr("data-price-id", priceId)
			.attr("data-event", currentEventId)
			.addClass(ticketClassName);

		return $ticket;
	}

	insertLoyaltyCategories(data) {
		const dropdownTemplate = document.getElementById("js-price-category-select-template");
		const dropdown = $(document.importNode(dropdownTemplate.content, true));
		let currentCategoryName = "Взрослый";
		data.allowedLoyaltyCategories.find(price => {
			if (data.price_id === price.price_view_id || data.price_view_id === price.price_view_id) {
				currentCategoryName = price.name;
			}
		});

		const list = dropdown.find(".dropdown__list");
		dropdown
		.find(".price-category-select")
		.data("item-id", "Взрослый" === currentCategoryName ? 0 : 1);
		
		list.append(
			this.insertLine({
				name: "Взрослый",
				id: 0,
				price_view_id: 0,
				description: "",
				checked: "Взрослый" == currentCategoryName,
			})
			);
			allowedLoyaltyCategories.forEach(item => {
			const checked = currentCategoryName == item.name;
			list.append(this.insertLine({ ...item, checked }));
		});

		return dropdown;
	}

	insertLine(item) {
		const lineTemplate = document.getElementById("js-price-category-select-line-template");
		const line = $(document.importNode(lineTemplate.content, true));
		const name = line.find(".js-price-category-select-line-name");
		const desc = line.find(".price-category-select__description");
		const uniqueId = "id" + Math.random().toString(16).slice(2);
		const input = line.find("input");
		name.text(item.name);
		desc.text(item.description);
		input.attr("name", `price_category_${uniqueId}`);
		input.val(item.price_view_id);
		input.data("name", item.name);
		if (item.checked) input.prop("checked", true);
		input.data("category-id", item.id ? item.id : 0);

		return line;
	}
}

export const orderHelper = new OrderHelper();
